import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import { connect } from 'react-redux';
import * as actions from '../actions';

class AddCustomer extends Component {
    state = {
        email: ''
    }

    handleChange = (e) => {
        const { value, name } = e.target;
        const nextState = {};
        nextState[name] = value;
        this.setState(nextState);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { addUser } = this.props;
        addUser(this.state);
    }

    render() {
        return (
            <div className="panel-custom-wrapper">
                <div className="panel panel-custom">
                    <div className="panel-heading">Change Password</div>
                    <form onSubmit={this.handleSubmit}>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <label>Customer Email Address</label>
                                        <input
                                            value={this.state.email} 
                                            onChange={this.handleChange}
                                            type="text"
                                            name="email" 
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="btn-custom text-right panel-footer">
                            <Link className="btn btn-primary" to="/profile/users">Cancel</Link>&nbsp;
                            <button className="btn btn-success">Add Customer</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        
        return {
            
        }
    },
    actions
)(AddCustomer)



// WEBPACK FOOTER //
// ./src/my-users/containers/AddCustomer.js